import { useState, useCallback, useEffect } from "react";

import "./ProductDetail.css";

export default function ProductDetail(props) {
  const [idx, setIdx] = useState(0);

  const [open, setOpen] = useState(false); // lightbox

  // get product
  const product = props.productInfo;

  // get images for the product
  const IMAGES = product.img.map((src) => src);

  const prev = useCallback(
    () => setIdx((i) => (i - 1 + IMAGES.length) % IMAGES.length),
    [IMAGES.length]
  );
  const next = useCallback(
    () => setIdx((i) => (i + 1) % IMAGES.length),
    [IMAGES.length]
  );

  // get category name for the product
  const categoryName = product.cat;
  // set background color based on category
  let bgColor;
  switch (categoryName) {
    case "Tã Dán":
      bgColor = "#d8c8f2";
      break;
    case "Tã Quần":
      bgColor = "#c9e4f6"; // light blue
      break;
    case "Newborn":
      bgColor = "#f3cce9"; // light purple
      break;
    default:
      bgColor = "#f5e9cf"; // default light color
  }

  // close lightbox with ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [prev, next]);

  return (
    <section className="pd container">
      {/* Left: images */}
      <div className="pd-left">
        <div className="pd-stage" style={{ backgroundColor: bgColor }}>
          <img
            src={IMAGES[idx]}
            alt={`diasper ${idx + 1}`}
            className="pd-img"
          />
          <button
            className="pd-arrow left"
            onClick={prev}
            aria-label="Previous image"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3b3b3b"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <button
            className="pd-arrow right"
            onClick={next}
            aria-label="Next image"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3b3b3b"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
          <button
            className="pd-zoom"
            onClick={() => setOpen(true)}
            aria-label="Open fullscreen"
          >
            ⤢
          </button>
        </div>

        {/* thumbs */}
        <div className="pd-thumbs" role="tablist" aria-label="Product images">
          {IMAGES.map((src, i) => (
            <button
              key={i}
              className={`thumb ${i === idx ? "active" : ""}`}
              onClick={() => setIdx(i)}
              role="tab"
              aria-selected={i === idx}
            >
              <img src={src} alt={`Thumbnail ${i + 1}`} />
            </button>
          ))}
        </div>
      </div>

      {/* Right: info */}
      <aside className="pd-right">
        <h1 className="pd-title">{product.title}</h1>
        <hr />
        <div className="pd-meta">
          <span>Mua hàng:</span>
          <a
            href="https://shopee.vn/tabimrumivietnam"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/images/shopee.png" alt="shopee" className="buy-icon" />
          </a>
          <a
            href="https://www.tiktok.com/@tabimrumi"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="/images/tiktok1.png"
              alt="shopee"
              className="buy-icon tiktok"
            />
          </a>
        </div>
        <div className="pd-meta">
          <span className="sep">|</span>
          <span>
            HSD: <strong>3 năm từ ngày sản xuất</strong>
          </span>
          <span className="sep">|</span>
          <span>
            NSX: <strong>In trên bao bì</strong>
          </span>
        </div>

        <dl className="pd-specs">
          <dt>Thành phần</dt>
          <dd>{product.composite}</dd>

          <dt>Cách bảo quản</dt>
          <dd>{product.keepInStore}</dd>
        </dl>
        <p>Thông tin chi tiết:</p>
        <table className="detail-table">
          <tbody>
            {product.description.map((row, index) => (
              <tr key={index}>
                <td className="label">{row.label}</td>
                <td className="value">{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="detail-note">
          * Chat ngay với chúng tôi để được tư vấn về size bỉm.
        </p>
      </aside>

      {/* Lightbox */}
      {open && (
        <div className="pd-lightbox" onClick={() => setOpen(false)}>
          <img src={IMAGES[idx]} alt="" onClick={(e) => e.stopPropagation()} />
          <button
            className="lb-close"
            aria-label="Close"
            onClick={() => setOpen(false)}
          >
            ×
          </button>
          <button
            className="lb-nav left"
            aria-label="Prev"
            onClick={(e) => {
              e.stopPropagation();
              prev();
            }}
          >
            ‹
          </button>
          <button
            className="lb-nav right"
            aria-label="Next"
            onClick={(e) => {
              e.stopPropagation();
              next();
            }}
          >
            ›
          </button>
        </div>
      )}
    </section>
  );
}
